/** @jsx jsx */
import { useEffect, useState } from 'react';
import { jsx } from '@emotion/react';
import { useIntl } from 'react-intl-next';
import { AtlassianIntelligenceLogo } from '../AtlassianIntelligenceLogo/AtlassianIntelligenceLogo';
import messages from '../../../utils/messages';
import { separatorStyles, svgIconStyles, wrapperStyle } from './styles';
import ToolbarButton from './ToolbarButton';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { bind } from 'bind-event-listener';
import { useEditorToolbarChangeDetector } from './useEditorToolbarChangeDetector';
const shouldShowSeparator = node => {
  var _node$previousElement;
  if (!node) {
    return false;
  }
  const prevSeparator = (_node$previousElement = node.previousElementSibling) === null || _node$previousElement === void 0 ? void 0 : _node$previousElement.querySelector(`:scope > span:last-child:empty`);
  const prevSeparatorVisible = prevSeparator && prevSeparator.clientWidth > 0;
  return !prevSeparatorVisible;
};
function useWindowWidth() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    function handleResize() {
      setWindowWidth(window.innerWidth);
    }
    const unbind = bind(window, {
      type: 'resize',
      listener: handleResize
    });
    return () => unbind();
  }, []);
  return windowWidth;
}

/**
 * @deprecated This button has ended up as part of our public api,
 * we don't expect additional products to make use of this button. Maybe move from public api in future.
 * If you need a button with the Atlassian intelligence logo,
 * we seperately export the Atlassian intelligence logo so you can build your own button
 */
export const AtlassianIntelligenceToolbarButton = ({
  onClick,
  disabled,
  ButtonWrapper
}) => {
  const {
    formatMessage
  } = useIntl();
  const title = getBooleanFF('platform.editor.ai-toolbar-copy_dyk06') ? formatMessage(messages.aiUniversalDescriptor) : formatMessage(messages.aiUniversalLongCallToAction);
  const [showSeparator, setShowSeperator] = useState(false);
  const width = useWindowWidth();
  const callbackRef = node => {
    const result = shouldShowSeparator(node);
    setShowSeperator(result);
  };

  // This const is derived from the breakpoint where the toolbar hides its icons. It is used to hide the text in the AI button.
  // Derived from values from platform/packages/editor/editor-core/src/ui/Appearance/FullPage/MainToolbar.tsx
  const AI_BUTTON_WIDTH_BREAKPOINT = 1076;
  const button = jsx(ToolbarButton, {
    onClick: onClick,
    buttonId: "atlassian-intelligence",
    "aria-label": title,
    testId: "atlassian-intelligence-toolbar-button",
    title: title,
    iconBefore: jsx(AtlassianIntelligenceLogo, {
      isDisabled: disabled
    }),
    disabled: disabled
  }, getBooleanFF('platform.editor.ai-toolbar-copy_dyk06') && width >= AI_BUTTON_WIDTH_BREAKPOINT && jsx("span", null, formatMessage(messages.aiUniversalShortCallToAction)));
  const toolbarMutationCount = useEditorToolbarChangeDetector(ButtonWrapper);
  const wrapped = ButtonWrapper ? jsx(ButtonWrapper, {
    key: `${toolbarMutationCount}-key-wrapper`
  }, button) : button;
  return jsx("span", {
    ref: callbackRef,
    css: [wrapperStyle, svgIconStyles]
  }, showSeparator && jsx("span", {
    "data-testid": "ai-toolbar-button-seperator",
    css: separatorStyles
  }), wrapped);
};